import { frontendURL } from '../../../helper/URLHelper';
const TareasView = () => import('./TareasView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/tareas'),
      name: 'tareas_view',
      component: TareasView,
      meta: { permissions: ['administrator', 'module_tareas'] },
    },
  ],
};
